export class DepositReqDto {
  constructor(public personalNumber: string,
              public successEndpoint: string,
              public failEndpoint: string,
              public instantDebitPaymentRequestId: string) {
  }
}
